// Descriptive alt text for product photos, built only from catalog data
// (size, product type, resolution, touch, interface) -- never an invented
// application. Example: "7 inch TFT Display 1024x600 with capacitive touch, HDMI - B-0526-QHB-0700 front view".
const clean = (v) => (v == null ? "" : String(v).replace(/\s+/g, " ").trim());

const sizeText = (raw) => {
  const s = clean(raw);
  if (!s) return "";
  if (/^\d+(\.\d+)?$/.test(s)) return `${s} inch`;
  return s.replace(/["”]|\bin\b\.?$/i, " inch").replace(/\s+/g, " ").trim();
};

export function productAltBase({ partNo, typeName, fields = {}, getField }) {
  const get = getField || ((k) => clean(fields[k]));
  const size = sizeText(get("Display Size"));
  const res = clean(get("Resolution"));
  const touch = clean(get("Touch Panel")).replace(/^CTP$/i, "capacitive").replace(/^RTP$/i, "resistive");
  const iface = clean(get("Display Interface"));
  const type = clean(typeName).replace(/displays$/i, "Display") || "display";

  let desc = [size, /display|panel|module|tft|lcd/i.test(type) ? type : `${type} display`]
    .filter(Boolean)
    .join(" ");
  if (res) desc += ` ${res}`;
  const extras = [touch && !/^(no|none|n\/a|-)$/i.test(touch) ? `${touch} touch` : "", iface].filter(Boolean);
  if (extras.length) desc += ` with ${extras.join(", ")}`;
  return partNo ? `${desc} - ${partNo}` : desc;
}
